import React, { useState, useEffect, useRef } from 'react';
import '../../../../Utility/Public/css/common.scss';
import '../Assets/css/homedoc.scss';
import '../Assets/css/homeresponsivedoc.scss';
import CustomInput from '../../../../Utility/Components/CustomInput';
import ErrorBoundary from '../../../../Utility/Components/ErrorBoundary';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import CommonDateTimePicker from '../../../../Utility/Components/CommonDateTimePicker';
import AutosuggestComponent from '../../../../Utility/Components/AutosuggestComponent';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { filterPanelList } from '../Controller/HomeController';
import {
    loaderStateTrue,
    loaderStateFalse,
    selectChooseBranch,
    userSearchData,
    roleWisePermission
} from '../../../../Actions/AllAction';
import {
    setToken,
    setUserCredentials,
    logOutApp
} from '../../../../../src/GlobalModules/Login/Actions/LoginAction';
import MultiRangeSlider from "../../../../Utility/Components/MultiRangeSlider";
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import SkeletonThemeFilterContent from '../../../../Utility/Components/SkeletonThemeFilterContent';
import Utility from '../../../../Utility/Utility';

function FilterPanel(props) {

    const [isViewportBottom, setIsViewportBottom] = useState(false);
    const [filterDataFromApi, setFilterDataFromApi] = useState({});
    const [isFilterDataChanged, setIsFilterDataChanged] = useState(false);
    const [apiCallFilterFinish, setApiCallFilterFinish] = useState(false);

    const [budgetRange, setBudgetRange] = useState({
        min: 0,
        max: 0
    });

    const [budgetValue, setBudgetValue] = useState({
        min: props.userSearchDataFromReducer?.filterData?.budget_min
            ? props.userSearchDataFromReducer.filterData.budget_min
            : 0,

        max: props.userSearchDataFromReducer?.filterData?.budget_max
            ? props.userSearchDataFromReducer.filterData.budget_max
            : 0
    });

    const [filterPanelData, setFilterPanelData] = useState({
        budget_min: props.userSearchDataFromReducer?.filterData?.budget_min
            ? props.userSearchDataFromReducer.filterData.budget_min
            : 0,

        budget_max: props.userSearchDataFromReducer?.filterData?.budget_max
            ? props.userSearchDataFromReducer.filterData.budget_max
            : 0,

        property_type: props.userSearchDataFromReducer?.filterData?.property_type
            ? props.userSearchDataFromReducer.filterData.property_type
            : [],

        property_rating: props.userSearchDataFromReducer?.filterData?.property_rating
            ? props.userSearchDataFromReducer.filterData.property_rating
            : [],

        amenities: props.userSearchDataFromReducer?.filterData?.amenities
            ? props.userSearchDataFromReducer.filterData.amenities
            : [],

        meals: props.userSearchDataFromReducer?.filterData?.meals
            ? props.userSearchDataFromReducer.filterData.meals
            : []
    });

    const [mealList, setMealList] = useState([
        "Breakfast",
        "Lunch",
        "Dinner"
    ]);

    const [propertyRatingList, setPropertyRatingList] = useState([
        "1 star",
        "2 stars",
        "3 stars",
        "4 stars",
        "5 stars"
    ]);

    /*
    ==========================================================
    NEW SECTION DATA
    ==========================================================
    */

    const [guestReviewScoreList, setGuestReviewScoreList] = useState([
        "5.0 Excellent",
        "4.0+ Very good",
        "3.0+ Good",
        "2.0+ Fair"
    ]);

    const [propertyClassificationList, setPropertyClassificationList] = useState([
        "5 Stars",
        "4 Stars",
        "3 Stars",
        "2 Stars",
        "1 Star"
    ]);

    const [selectedGuestReviewScore, setSelectedGuestReviewScore] = useState([]);

    const [selectedPropertyClassification, setSelectedPropertyClassification] = useState([]);

    /*
    ==========================================================
    NEW AMENITIES SECTION
    ==========================================================
    */

    const [newAmenitiesList, setNewAmenitiesList] = useState([
        "Air Conditioning",
        "Wi-Fi",
        "BBQ Grill",
        "Washing machine",
        "TV",
        "Kitchen"
    ]);

    const [selectedNewAmenities, setSelectedNewAmenities] = useState([]);


    useEffect(() => {

        const handleScroll = () => {

            const scrollPosition = window.scrollY;
            const windowHeight = window.innerHeight;
            const documentHeight = document.documentElement.scrollHeight;
            const scrollTop = window.scrollY;

            if (scrollTop >= 1050) {

                setIsViewportBottom(true);

            } else {

                setIsViewportBottom(false);

            }

            if (scrollPosition + windowHeight > documentHeight - 600) {

                setIsViewportBottom(false);

            }

        };

        window.addEventListener('scroll', handleScroll);

        return () => {

            window.removeEventListener('scroll', handleScroll);

        };

    }, []);


    //initially fetch left filter panel data from api
    useEffect(() => {

        getFilterPanelList();

    }, []);


    // Sync local state with Redux when URL parameters are loaded
    useEffect(() => {

        if (props.userSearchDataFromReducer?.filterData) {
            const reduxFilter = props.userSearchDataFromReducer.filterData;
            const hasAnyFilter = Object.keys(reduxFilter).length > 0;
            if (hasAnyFilter) {
                setFilterPanelData(prev => ({

                    budget_min:
                        reduxFilter.budget_min !== undefined
                            ? reduxFilter.budget_min
                            : prev.budget_min,

                    budget_max:
                        reduxFilter.budget_max !== undefined
                            ? reduxFilter.budget_max
                            : prev.budget_max,

                    property_type:
                        Array.isArray(reduxFilter.property_type)
                            ? [...reduxFilter.property_type]
                            : (
                                reduxFilter.property_type
                                    ? [reduxFilter.property_type]
                                    : prev.property_type
                            ),

                    property_rating:
                        Array.isArray(reduxFilter.property_rating)
                            ? [...reduxFilter.property_rating]
                            : (
                                reduxFilter.property_rating
                                    ? [reduxFilter.property_rating]
                                    : prev.property_rating
                            ),

                    amenities:
                        Array.isArray(reduxFilter.amenities)
                            ? [...reduxFilter.amenities]
                            : (
                                reduxFilter.amenities
                                    ? [reduxFilter.amenities]
                                    : prev.amenities
                            ),

                    meals:
                        Array.isArray(reduxFilter.meals)
                            ? [...reduxFilter.meals]
                            : (
                                reduxFilter.meals
                                    ? [reduxFilter.meals]
                                    : prev.meals
                            )

                }));

                if (
                    reduxFilter.budget_min !== undefined ||
                    reduxFilter.budget_max !== undefined
                ) {

                    setBudgetValue(prev => ({

                        min:
                            reduxFilter.budget_min !== undefined
                                ? reduxFilter.budget_min
                                : prev.min,

                        max:
                            reduxFilter.budget_max !== undefined
                                ? reduxFilter.budget_max
                                : prev.max

                    }));

                }
            }

        }

    }, [props.userSearchDataFromReducer?.filterData]);


    //fetch left filter panel data api
    const getFilterPanelList = () => {

        const {
            loaderStateTrue,
            loaderStateFalse
        } = props;

        let data = {};

        setApiCallFilterFinish(false);

        setFilterDataFromApi([]);

        filterPanelList(data)
            .then((response) => {

                setFilterDataFromApi(response.data);

                setApiCallFilterFinish(true);

                props.filterApiSuccessCheckFn(true);

            })
            .catch((error) => {

                setApiCallFilterFinish(true);

            });

    };


    //set budget range input data
    useEffect(() => {

        setBudgetRange({
            min: 0,
            max: filterDataFromApi.room_rate
                ? parseInt(filterDataFromApi.room_rate)
                : Infinity
        });

        setBudgetValue({

            min: props.userSearchDataFromReducer?.filterData?.budget_min
                ? props.userSearchDataFromReducer.filterData.budget_min
                : 0,

            max: props.userSearchDataFromReducer?.filterData?.budget_max
                ? props.userSearchDataFromReducer.filterData.budget_max
                : filterDataFromApi.room_rate
                    ? parseInt(filterDataFromApi.room_rate)
                    : 0

        });

    }, [filterDataFromApi]);


    /*
    ==========================================================
    PROPERTY TYPE UI
    ==========================================================
    */

    const propertyTypeUi = () => {

        if (
            !filterDataFromApi ||
            !filterDataFromApi.property_type
        ) {

            return null;

        }

        let propertyType = filterDataFromApi.property_type;

        const propertyTypeArray =
            Array.isArray(filterPanelData.property_type)
                ? filterPanelData.property_type
                : (
                    filterPanelData.property_type
                        ? [filterPanelData.property_type]
                        : []
                );

        let arry = [];

        if (propertyType.length > 0) {

            propertyType.map((val, idx) => {

                arry.push(

                    <li key={`checkbox_${idx}`}>

                        <label className="chkContainer">

                            {val.name}

                            <input
                                type="checkbox"
                                value={val.name}
                                onChange={(e) => handlePropertyTypeCheckboxChange(e, val)}
                                checked={propertyTypeArray.includes(val.name)}
                            />

                            <span className="checkmark"></span>

                        </label>

                    </li>

                );

            });

        }

        return arry;

    };


    const handlePropertyTypeCheckboxChange = (event, val) => {

        const { checked } = event.target;

        setFilterPanelData(prev => ({
            ...prev,
            property_type: checked ? [val.name] : [],
            property_rating: []
        }));

        setIsFilterDataChanged(true);

    };


    const shouldShowPropertyRating = () => {

        const propertyTypes =
            Array.isArray(filterPanelData.property_type)
                ? filterPanelData.property_type
                : (
                    filterPanelData.property_type
                        ? [filterPanelData.property_type]
                        : []
                );

        if (
            propertyTypes.length === 0 ||
            !filterDataFromApi?.property_type
        ) {

            return false;

        }

        const selectedName = propertyTypes[0];

        const found = filterDataFromApi.property_type.find(
            pt => pt.name === selectedName
        );

        return found?.is_star_category === true;

    };


    /*
    ==========================================================
    PROPERTY RATING UI
    ==========================================================
    */

    const propertyRatingUi = () => {

        let arry = [];

        if (propertyRatingList.length > 0) {

            propertyRatingList.map((val, idx) => {

                const propertyRatings =
                    Array.isArray(filterPanelData.property_rating)
                        ? filterPanelData.property_rating
                        : (
                            filterPanelData.property_rating
                                ? [filterPanelData.property_rating]
                                : []
                        );

                arry.push(

                    <li key={idx}>

                        <label className="chkContainer">

                            {val}

                            <input
                                type="checkbox"
                                value={val}
                                onChange={handlePropertyRatingCheckboxChange}
                                checked={propertyRatings.includes(val)}
                            />

                            <span className="checkmark"></span>

                        </label>

                    </li>

                );

            });

        }

        return arry;

    };


    const handlePropertyRatingCheckboxChange = (event) => {

        const {
            value,
            checked
        } = event.target;

        setFilterPanelData(prev => ({
            ...prev,
            property_rating: checked
                ? [...(prev.property_rating || []), value]
                : (prev.property_rating || []).filter(item => item !== value)
        }));

        setIsFilterDataChanged(true);

    };


    /*
    ==========================================================
    PROPERTY AMENITIES UI - EXISTING
    ==========================================================
    */

    const amenitiesTypeUi = () => {

        if (
            !filterDataFromApi ||
            !filterDataFromApi.amenities_type
        ) {

            return null;

        }

        let amenitiesType = filterDataFromApi.amenities_type;

        const amenitiesArray =
            Array.isArray(filterPanelData.amenities)
                ? filterPanelData.amenities
                : (
                    filterPanelData.amenities
                        ? [filterPanelData.amenities]
                        : []
                );

        let arry = [];

        if (amenitiesType.length > 0) {

            amenitiesType.map((val, idx) => {

                arry.push(

                    <li key={idx}>

                        <label className="chkContainer">

                            {val}

                            <input
                                type="checkbox"
                                value={val}
                                onChange={handleAmenitiesTypeCheckboxChange}
                                checked={amenitiesArray.includes(val)}
                            />

                            <span className="checkmark"></span>

                        </label>

                    </li>

                );

            });

        }

        return arry;

    };


    const handleAmenitiesTypeCheckboxChange = (event) => {

        const {
            value,
            checked
        } = event.target;

        setFilterPanelData(prev => ({
            ...prev,
            amenities: checked
                ? [...(prev.amenities || []), value]
                : (prev.amenities || []).filter(item => item !== value)
        }));

        setIsFilterDataChanged(true);

    };


    /*
    ==========================================================
    MEALS UI
    ==========================================================
    */

    const mealListUi = () => {

        const mealsArray =
            Array.isArray(filterPanelData.meals)
                ? filterPanelData.meals
                : (
                    filterPanelData.meals
                        ? [filterPanelData.meals]
                        : []
                );

        let arry = [];

        if (mealList.length > 0) {

            mealList.map((val, idx) => {

                arry.push(

                    <li key={idx}>

                        <label className="chkContainer">

                            {val}

                            <input
                                type="checkbox"
                                value={val}
                                onChange={mealListCheckboxChange}
                                checked={mealsArray.includes(val)}
                            />

                            <span className="checkmark"></span>

                        </label>

                    </li>

                );

            });

        }

        return arry;

    };


    const mealListCheckboxChange = (event) => {

        const {
            value,
            checked
        } = event.target;

        setFilterPanelData(prev => ({
            ...prev,
            meals: checked
                ? [...(prev.meals || []), value]
                : (prev.meals || []).filter(item => item !== value)
        }));

        setIsFilterDataChanged(true);

    };


    /*
    ==========================================================
    GUEST REVIEW SCORE UI
    ==========================================================
    */

    const guestReviewScoreUi = () => {

        let arry = [];

        if (guestReviewScoreList.length > 0) {

            guestReviewScoreList.map((val, idx) => {

                arry.push(

                    <li key={idx}>

                        <label className="chkContainer">

                            {val}

                            <input
                                type="checkbox"
                                value={val}
                                checked={selectedGuestReviewScore.includes(val)}
                                onChange={handleGuestReviewScoreCheckboxChange}
                            />

                            <span className="checkmark"></span>

                        </label>

                    </li>

                );

            });

        }

        return arry;

    };


    const handleGuestReviewScoreCheckboxChange = (event) => {

        const {
            value,
            checked
        } = event.target;

        if (checked) {

            setSelectedGuestReviewScore([
                ...selectedGuestReviewScore,
                value
            ]);

        } else {

            setSelectedGuestReviewScore(
                selectedGuestReviewScore.filter(
                    item => item !== value
                )
            );

        }

    };


    /*
    ==========================================================
    PROPERTY CLASSIFICATION UI
    ==========================================================
    */

    const propertyClassificationUi = () => {

        let arry = [];

        if (propertyClassificationList.length > 0) {

            propertyClassificationList.map((val, idx) => {

                arry.push(

                    <li key={idx}>

                        <label className="chkContainer">

                            {val}

                            <input
                                type="checkbox"
                                value={val}
                                checked={selectedPropertyClassification.includes(val)}
                                onChange={handlePropertyClassificationCheckboxChange}
                            />

                            <span className="checkmark"></span>

                        </label>

                    </li>

                );

            });

        }

        return arry;

    };


    const handlePropertyClassificationCheckboxChange = (event) => {

        const {
            value,
            checked
        } = event.target;

        if (checked) {

            setSelectedPropertyClassification([
                ...selectedPropertyClassification,
                value
            ]);

        } else {

            setSelectedPropertyClassification(
                selectedPropertyClassification.filter(
                    item => item !== value
                )
            );

        }

    };


    /*
    ==========================================================
    NEW AMENITIES PILL ICONS
    ==========================================================
    */

    const getAmenityIcon = (amenityName) => {

        switch (amenityName) {

            case "Air Conditioning":

                return (
                    <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <line x1="12" y1="2" x2="12" y2="22" />
                        <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
                        <line x1="2" y1="12" x2="22" y2="12" />
                        <line x1="4.93" y1="19.07" x2="19.07" y2="4.93" />
                    </svg>
                );


            case "Wi-Fi":

                return (
                    <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M5 12.55a11 11 0 0 1 14.08 0" />
                        <path d="M8.5 16.1a6 6 0 0 1 7 0" />
                        <path d="M12 20h.01" />
                    </svg>
                );


            case "BBQ Grill":

                return (
                    <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M7 4c-1 1-1 2 0 3" />
                        <path d="M12 4c-1 1-1 2 0 3" />
                        <path d="M17 4c-1 1-1 2 0 3" />
                        <path d="M5 10h14" />
                        <path d="M7 10c0 3 2 5 5 5s5-2 5-5" />
                        <path d="M9 15l-2 5" />
                        <path d="M15 15l2 5" />
                    </svg>
                );


            case "Washing machine":

                return (
                    <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <rect x="5" y="2" width="14" height="20" rx="2" />
                        <circle cx="12" cy="14" r="4" />
                        <circle cx="8" cy="6" r="1" />
                        <line x1="12" y1="6" x2="16" y2="6" />
                    </svg>
                );


            case "TV":

                return (
                    <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <rect x="3" y="5" width="18" height="13" rx="2" />
                        <line x1="8" y1="21" x2="16" y2="21" />
                        <line x1="12" y1="18" x2="12" y2="21" />
                    </svg>
                );


            case "Kitchen":

                return (
                    <svg
                        width="13"
                        height="13"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.7"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <rect x="4" y="3" width="16" height="18" rx="2" />
                        <line x1="4" y1="10" x2="20" y2="10" />
                        <circle cx="8" cy="6.5" r="1" />
                        <circle cx="12" cy="6.5" r="1" />
                        <circle cx="16" cy="6.5" r="1" />
                        <rect x="8" y="13" width="8" height="5" rx="1" />
                    </svg>
                );


            default:

                return null;

        }

    };


    /*
    ==========================================================
    NEW AMENITIES PILL UI
    ==========================================================
    */

    const newAmenitiesUi = () => {

        return newAmenitiesList.map((val, idx) => {

            const isSelected = selectedNewAmenities.includes(val);

            return (

                <li
                    key={idx}
                    style={{
                        listStyle: 'none',
                        margin: 0,
                        padding: 0
                    }}
                >

                    <button
                        type="button"
                        onClick={() => {

                            if (isSelected) {

                                setSelectedNewAmenities(
                                    selectedNewAmenities.filter(
                                        item => item !== val
                                    )
                                );

                            } else {

                                setSelectedNewAmenities([
                                    ...selectedNewAmenities,
                                    val
                                ]);

                            }

                        }}
                        style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px',

                            width: 'auto',
                            minHeight: '28px',

                            padding: '5px 10px',

                            border: isSelected
                                ? '1px solid #333333'
                                : '1px solid #c5c9ce',

                            borderRadius: '20px',

                            background: isSelected
                                ? '#f3f3f3'
                                : '#ffffff',

                            color: '#333333',

                            fontFamily: 'inherit',
                            fontSize: '12px',
                            fontWeight: '400',
                            lineHeight: '16px',

                            whiteSpace: 'nowrap',

                            cursor: 'pointer',

                            outline: 'none',

                            boxShadow: 'none',

                            transition: 'all 0.2s ease'
                        }}
                    >

                        <span
                            style={{
                                width: '14px',
                                minWidth: '14px',
                                height: '14px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#333333'
                            }}
                        >
                            {getAmenityIcon(val)}
                        </span>

                        <span>
                            {val}
                        </span>

                    </button>

                </li>

            );

        });

    };


    useEffect(() => {

        if (isFilterDataChanged) {

            setIsFilterDataChanged(false);

        }

    }, [isFilterDataChanged]);


    const applyFilters = () => {

        dispatchFilterData();

    };


    const lastFilterData = useRef(null);


    useEffect(() => {

        if (filterPanelData) {

            lastFilterData.current = {
                ...filterPanelData
            };

            props.sendDataToParent(filterPanelData);

        }

    }, [filterPanelData]);


    const dispatchFilterData = () => {

        const currentFilterData = filterPanelData || lastFilterData.current;

        if (currentFilterData) {

            let reducerData =
                props.userSearchDataFromReducer || {};

            let tempSearchData = {

                ...reducerData,

                filterData: currentFilterData

            };

            props.userSearchData(tempSearchData);

            if (
                props.searchHotelBranch &&
                typeof props.searchHotelBranch === 'function'
            ) {

                props.searchHotelBranch(tempSearchData);

            }

        }

    };


    /*
    ==========================================================
    BUDGET
    ==========================================================
    */

    const handleSliderChange = (newValue) => {

        const newMin = Math.max(
            budgetRange.min,
            newValue.min
        );

        const newMax = Math.min(
            budgetRange.max,
            newValue.max
        );

        if (newValue.max <= budgetRange.max) {

            setBudgetValue({

                min: newMin,

                max: newMax

            });

            setIsFilterDataChanged(true);

        }

    };


    const handleSliderFinalChange = (newValue) => {

        setFilterPanelData(prev => ({

            ...prev,

            budget_min: newValue.min,

            budget_max: newValue.max

        }));

        setIsFilterDataChanged(true);

    };


    /*
    ==========================================================
    JSX
    ==========================================================
    */

    return (

        <>

            {apiCallFilterFinish

                ?

                <div
                    className={` ${props.leftSearchFlag +
                        ' ' +
                        "col-xl-3 col-lg-3 col-md-4 col-sm-4 pushMenu"
                        }`}
                >

                    <div className='searchLeft'>

                        <button
                            onClick={() => {
                                props.crossFN();
                            }}
                            className='crossBtn'
                        >
                            ✖
                        </button>


                        <div
                            className={`innsearchLeftBox ${isViewportBottom
                                    ? 'is-sticky'
                                    : ''
                                }`}
                        >

                            <div
                                className="filter-header"
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '15px',
                                    background: '#f1f1f1',
                                    borderBottom: '1px solid #dddddd'
                                }}
                            >

                                <h6
                                    style={{
                                        margin: 0
                                    }}
                                >
                                    Filter by
                                </h6>


                                <button
                                    className="apply-filter-btn"
                                    onClick={dispatchFilterData}
                                    style={{
                                        background: '#75723d',
                                        padding: '5px 10px',
                                        border: 'none',
                                        color: '#fff',
                                        borderRadius: '3px',
                                        marginRight: '5px',
                                        fontSize: '12px'
                                    }}
                                >
                                    Apply Filter
                                </button>

                            </div>


                            <div className='innfilterBoxes'>


                                {/* BUDGET */}

                                <div className='filterBox'>

                                    <strong>
                                        Your budget (per night)
                                    </strong>

                                    <InputRange
                                        minValue={budgetRange.min}
                                        maxValue={budgetRange.max}
                                        value={budgetValue}
                                        onChange={handleSliderChange}
                                        onChangeComplete={handleSliderFinalChange}
                                    />

                                </div>


                                {/* PROPERTY TYPE */}

                                <div className='filterBox'>

                                    <strong>
                                        Property type
                                    </strong>

                                    <ul key={'property_type'}>

                                        {propertyTypeUi()}

                                    </ul>

                                </div>


                                {/* PROPERTY RATING */}

                                {shouldShowPropertyRating() &&

                                    <div className='filterBox'>

                                        <strong>
                                            Property rating
                                        </strong>

                                        <ul key={'property_rating'}>

                                            {propertyRatingUi()}

                                        </ul>

                                    </div>

                                }


                                {/* PROPERTY AMENITIES - EXISTING */}

                                <div className='filterBox'>

                                    <strong>
                                        Property amenities
                                    </strong>

                                    <ul key={'property_amenities'}>

                                        {amenitiesTypeUi()}

                                    </ul>

                                </div>


                                {/* MEALS */}

                                <div className='filterBox'>

                                    <strong>
                                        Meals
                                    </strong>

                                    <ul key={'meal_list'}>

                                        {mealListUi()}

                                    </ul>

                                </div>


                                {/* GUEST REVIEW SCORE */}

                                <div className='filterBox'>

                                    <strong>
                                        Guest Review Score
                                    </strong>

                                    <ul key={'guest_review_score'}>

                                        {guestReviewScoreUi()}

                                    </ul>

                                </div>


                                {/* PROPERTY CLASSIFICATION */}

                                <div className='filterBox'>

                                    <strong>
                                        Property Classification
                                    </strong>

                                    <ul key={'property_classification'}>

                                        {propertyClassificationUi()}

                                    </ul>

                                </div>


                                {/* NEW AMENITIES DESIGN */}

                                <div className='filterBox amenitiesfilterBox'>

                                    <strong>
                                        Amenities
                                    </strong>

                                    <ul
                                        key={'new_amenities'}
                                        style={{
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            gap: '7px',
                                            padding: 0,
                                            margin: '10px 0 0 0',
                                            alignItems: 'flex-start'
                                        }}
                                    >

                                        {newAmenitiesUi()}

                                    </ul>

                                </div>


                                {/* APPLY FILTER BUTTON */}

                                <div
                                    className='filterBox'
                                    style={{
                                        textAlign: 'center'
                                    }}
                                >

                                    <button
                                        onClick={dispatchFilterData}
                                        className='btn btn-primary btn-block'
                                        style={{
                                            background: '#75723d',
                                            padding: '5px 10px',
                                            border: 'none',
                                            color: '#fff',
                                            borderRadius: '3px',
                                            fontSize: '12px'
                                        }}
                                    >

                                        Apply Filters

                                    </button>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                :

                <SkeletonThemeFilterContent />

            }

        </>

    );

}


FilterPanel.defaultProps = {

};


const mapStateToProps = (globalState) => {

    return {

        userCredentials:
            globalState.LoginReducer.userCredentials,

        userSearchDataFromReducer:
            globalState.mainReducerData.userSearchData

    };

};


export default connect(
    mapStateToProps,
    {
        loaderStateTrue,
        loaderStateFalse,
        setUserCredentials,
        logOutApp,
        roleWisePermission,
        userSearchData,
        setToken,
    }
)(FilterPanel);